<template>
  <div style="width:80%;margin:auto;margin-top:1vh;">
    <h3 style="text-align: center;">Share your battle!</h3>


    <div v-for="(d, i) in queueData" :key="d" style="width:100%;"
         :style="[i % 2 ? {backgroundColor: '#707070'} : {backgroundColor: '#494949'}]">

      <div style="display: flex;justify-content: center;font-weight:bold;">
        {{ d['battle_player__unique_battle_key'] }} <span v-if="d['watched']">✅</span>
      </div>
      <div style="display: flex;justify-content: center;">


        <div>
          {{ d['battle_player__trainer__username'] }}
        </div>

        <div style="font-weight: bold;">&nbsp;vs&nbsp;</div>

        <div>
          {{ d['battle_player_2__trainer__username'] }}
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {onMounted} from "@vue/runtime-core";
import {battleContent, currentView} from "../../utils/globals";
import {showModalMsg} from "../../components/Modal/modalUtils";
import {translation} from "../../utils/translations";
import Battle from "./Battle.vue";
import axios from "axios";
import {battleUri} from "../../utils/settings";
import {ref} from "vue";

export default {
  name: "BattleWatchQueue",
  setup() {
    const queueData = ref([]);
    const getBattleQueue = async () => {
      await axios.get(battleUri + "api/game/ext/battle/get-watch-queue/")
          .then((resp) => {
            queueData.value = resp.data.queue;

            let found = false;
            for (let i = 0; i < queueData.value.length; i++) {
              if (!queueData.value[i]['watched']) {
                viewBattle(queueData.value[i]['battle_player__unique_battle_key'], false);
                found = true;
                break;
              }
            }

            if (!found) {
              setTimeout(() => {
                getBattleQueue()
              }, 5000);
            }


          })
          .catch(() => {
            setTimeout(() => {
              getBattleQueue()
            }, 5000);
          })
    };


    const viewBattle = async (battleViewID, liveView) => {
      if (battleViewID === undefined || battleViewID === null) {
        showModalMsg(translation.battle.battleDoesntExist);
        return;
      }
      if (battleViewID.length < 4) {
        showModalMsg(translation.battle.battleDoesntExist);
        return;
      }

      battleContent.value = {
        isViewer: true,
        liveView: liveView,
        id: battleViewID,
        speed: 0.5,
        paused: false
      };
      currentView.value = Battle;
    };

    onMounted(() => {
      getBattleQueue();
    });

    return {
      queueData
    }
  }
}
</script>

<style scoped>

</style>